import { QueryFunction } from '@tanstack/react-query';
import { BorrowerpairResponse, LoanBorrowerPairs } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

const getBorrowerpairData: QueryFunction<
  LoanBorrowerPairs[],
  ['/get-borrowerpair-data', string]
> = async ({ queryKey }) => {
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<BorrowerpairResponse>(
    `/${queryKey[1]}/loan-borrower-pair`,
    {
      method: 'GET',
    },
  );
  if (response.data) return response.data.data;

  throw new Error('Failed to fetch borrower pair data');
};

export default getBorrowerpairData;
